import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import decode from 'jwt-decode';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable()
export class AuthGuard  {

    userData: any;

    constructor(
        private router: Router,
        public auth: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const api_key = localStorage.getItem('api_key');
        let userData: any;

        if (api_key > '') {
            try {
                userData = decode(api_key);
            } catch {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
            this.auth.user = userData;
            if (typeof userData.id !== 'undefined') {
                return true;
            } else {
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
        } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }

        return false;

    }

}
